require('./Resources/js/angular/module');
require('./Resources/js/angular/controllers/SearchCtrl');
require('./Resources/js/angular/controllers/SearchFiltersCtrl');
require('./Resources/js/angular/controllers/SearchFormCtrl');
require('./Resources/js/angular/directives/satvFilterTree');
require('./Resources/js/angular/services/Search');


// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/index.js